var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#6B51EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 9.49609L9.7832 7.41797C9.92993 7.27059 10.1043 7.15366 10.2964 7.07389C10.4885 6.99412 10.6944 6.95308 10.9023 6.95313C11.3262 6.95313 11.7246 7.11914 12.0234 7.41797L14.2617 9.65625C14.4091 9.80298 14.526 9.97738 14.6058 10.1694C14.6856 10.3615 14.7266 10.5674 14.7266 10.7754C14.7266 11.1992 14.5605 11.5977 14.2617 11.8965L12.625 13.5332C13.0081 14.3777 13.5408 15.1459 14.1973 15.8008C14.8521 16.4589 15.6203 16.9935 16.4648 17.3789L18.1016 15.7422C18.2483 15.5948 18.4227 15.4779 18.6148 15.3981C18.8068 15.3183 19.0127 15.2773 19.2207 15.2773C19.6445 15.2773 20.043 15.4434 20.3418 15.7422L22.582 17.9785C22.7296 18.1255 22.8466 18.3002 22.9264 18.4926C23.0062 18.685 23.0471 18.8913 23.0469 19.0996C23.0469 19.5234 22.8809 19.9219 22.582 20.2207L20.5059 22.2969C20.0293 22.7754 19.3711 23.0469 18.6953 23.0469C18.5527 23.0469 18.416 23.0352 18.2812 23.0117C15.6484 22.5781 13.0371 21.1777 10.9297 19.0723C8.82422 16.9688 7.42578 14.3594 6.98633 11.7188C6.85351 10.9121 7.12109 10.082 7.70312 9.49609Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.475b989d6e0f80d3b652193f1806da96.svg";
export { ForwardRef as ReactComponent };